export default __webpack_public_path__ + "static/media/Tepic.949f9cc3.jpg";